import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React from 'react';
import DataView from '../../components/DataView';
import EstadosView from '../../components/EstadosView';
import ContainerDataView from './ContainerDataView';

// const useStyles = makeStyles(theme => ({
//   expand: {
//     transform: 'rotate(0deg)',
//     marginRight: 'auto',
//     transition: theme.transitions.create('transform', {
//       duration: theme.transitions.duration.shortest
//     })
//   },
//   expandOpen: {
//     transform: 'rotate(180deg)'
//   }
// }));
const DatosFormularioView = ({ values, eventos, isPhone }) => {
  // const classes = useStyles();
  // const [expanded, setExpanded] = React.useState(false);

  // const handleExpandClick = () => {
  //   setExpanded(!expanded);
  // };
  // const details = [
  //   {
  //     fecha: '07:00 01/11/2024',
  //     titulo: 'Llegado a la instalación regional de USPS',
  //     subtitulo: 'CENTRO DE DISTRIBUCIÓN AUSTIN TX'
  //   },
  //   {
  //     fecha: '08:00 01/11/2024',
  //     titulo: 'En tránsito hacia la siguiente instalación'
  //   },
  //   {
  //     fecha: '09:00 01/11/2024',
  //     titulo: 'Llegado a la instalación de origen de USPS',
  //     subtitulo: 'SAINT PAUL, MN 55131'
  //   },
  //   {
  //     fecha: '10:00 01/11/2024',
  //     titulo: 'Entregado',
  //     subtitulo: 'CIRCLE PINES'
  //   }
  // ];
  return (
    <>
      <ContainerDataView title="Datos del Formulario">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                  Detalle
                </Typography>
                <Grid container item xs={12} spacing={isPhone ? 1 : 0}>
                  <Grid item xs={12}>
                    <DataView
                      label="Estado"
                      value={values.estadoActual}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Flete facturado (Gs.)"
                      value={values.totalFlete}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Cantidad de bultos"
                      value={values.cantidadBultos}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Peso tarifado (Kg.)"
                      value={values.pesoTarifado}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Nro. de guía"
                      value={values.nroGuia}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Código TEES"
                      value={values.codigoTees}
                      isPhone={isPhone}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <DataView
                      label="Código de despacho"
                      value={values.codigoDespacho}
                      isPhone={isPhone}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" component="h2" gutterBottom>
                  Estado
                </Typography>
                <EstadosView
                  eventos={eventos}
                  codigoTees={values.codigoTees}
                  nroGuia={values.nroGuia}
                  codigoDespacho={values.codigoDespacho}
                />
              </CardContent>
              {/* <CardActions disableSpacing>
                <Button
                  color="primary"
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="show more"
                  startIcon={
                    <ExpandMoreIcon
                      className={clsx(classes.expand, {
                        [classes.expandOpen]: expanded
                      })}
                    />
                  }
                >
                  Estado del envío
                </Button>
              </CardActions> */}
              {/* <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent>
                  <Tracking details={details} />
                </CardContent>
              </Collapse> */}
            </Card>
          </Grid>
        </Grid>
      </ContainerDataView>
    </>
  );
};

export default inject('datos')(observer(withSnackbar(DatosFormularioView)));
